import _ from 'lodash';

import {
  SOCKET_TYPES,
  EXPANSIONS,
} from 'shared/constants';
import prefGroup from 'shared/itemPrefGroup';
import { deepFreeze } from 'shared/util';

import {
  enchantInfo,
  enchantInfoWithCraftingQualties,
} from 'shared/enchants';

/////////////////////////////////////////////////////////////////////
//
// ... GEMS ...
//
/////////////////////////////////////////////////////////////////////

export const getGemInfo = _.memoize(() => {
  const gems = [
    //
    //
    // THE WAR WITHIN
    //
    //

    // 11.0.7 Citrine Gems

    // THUNDER
    // Storm Sewer's Citrine
    {
      ...enchantInfo(7579),
      group: 'citrine_thunder',
      preferred: prefGroup.all,
    },
    // Roaring War-Queen's Citrine
    {
      ...enchantInfo(7585),
      group: 'citrine_thunder',
    },
    // Stormbringer's Runed Citrine
    {
      ...enchantInfo(7575),
      group: 'citrine_thunder',
      preferred: prefGroup.all,
    },
    // Thunderlord's Crackling Citrine
    {
      ...enchantInfo(7571),
      group: 'citrine_thunder',
      preferred: prefGroup.all,
    },

    // SEA
    // Mariner's Hallowed Citrine
    {
      ...enchantInfo(7581),
      group: 'citrine_sea',
    },
    // Seabed Leviathan's Citrine
    {
      ...enchantInfo(7584),
      group: 'citrine_sea',
      preferred: prefGroup.all,
    },
    // Fathomdweller's Runed Citrine
    {
      ...enchantInfo(7576),
      group: 'citrine_sea',
      preferred: prefGroup.all,
    },
    // Undersea Overseer's Citrine
    {
      ...enchantInfo(7573),
      group: 'citrine_sea',
      preferred: prefGroup.all,
    },

    // WIND
    // Old Salt's Bardic Citrine
    {
      ...enchantInfo(7580),
      group: 'citrine_wind',
    },
    // Legendary Skipper's Citrine
    {
      ...enchantInfo(7583),
      group: 'citrine_wind',
      preferred: prefGroup.all,
    },
    // Windsinger's  Runed Citrine
    {
      ...enchantInfo(7577),
      group: 'citrine_wind',
      preferred: prefGroup.all,
    },
    // Squall Sailor's Citrine
    {
      ...enchantInfo(7572),
      group: 'citrine_wind',
      preferred: prefGroup.all,
    },


    // 11.0.0 - Base Expansion

    // Quick Ruby
    ...enchantInfoWithCraftingQualties({
      enchantIds: [7146, 7147, 7208],
      shortName: 'C/H',
      group: 'crit',
      preferred: prefGroup.all,
    }),
    // Masterful Ruby
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7148,
      shortName: 'C/M',
      group: 'crit',
      preferred: prefGroup.all,
    }),
    // Versatile Ruby
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7151,
      shortName: 'C/V',
      group: 'crit',
      preferred: prefGroup.all,
    }),
    // Deadly Ruby
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7154,
      shortName: 'C',
      group: 'crit',
      preferred: prefGroup.all,
    }),

    // Deadly Sapphire
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7157,
      shortName: 'V/C',
      group: 'vers',
      preferred: prefGroup.all,
    }),
    // Quick Sapphire
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7160,
      shortName: 'V/H',
      group: 'vers',
      preferred: prefGroup.all,
    }),
    // Masterful Sapphire
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7163,
      shortName: 'V/M',
      group: 'vers',
      preferred: prefGroup.all,
    }),
    // Versatile Sapphire
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7166,
      shortName: 'V',
      group: 'vers',
      preferred: prefGroup.all,
    }),

    // Deadly Emerald
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7169,
      shortName: 'H/C',
      group: 'haste',
      preferred: prefGroup.all,
    }),
    // Masterful Emerald
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7172,
      shortName: 'H/M',
      group: 'haste',
      preferred: prefGroup.all,
    }),
    // Versatile Emerald
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7175,
      shortName: 'H/V',
      group: 'haste',
      preferred: prefGroup.all,
    }),
    // Quick Emerald
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7178,
      shortName: 'H',
      group: 'haste',
      preferred: prefGroup.all,
    }),

    // Deadly Onyx
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7181,
      shortName: 'M/C',
      group: 'mast',
      preferred: prefGroup.all,
    }),
    // Quick Onyx
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7184,
      shortName: 'M/H',
      group: 'mast',
      preferred: prefGroup.all,
    }),
    // Versatile Onyx
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7187,
      shortName: 'M/V',
      group: 'mast',
      preferred: prefGroup.all,
    }),
    // Masterful Onyx
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7190,
      shortName: 'M',
      group: 'mast',
      preferred: prefGroup.all,
    }),

    // Deadly Amber
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7193,
      shortName: 'Sta/C',
      group: 'stam',
      preferred: prefGroup.all,
    }),
    // Quick Amber
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7196,
      shortName: 'Sta/H',
      group: 'stam',
      preferred: prefGroup.all,
    }),
    // Masterful Amber
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7199,
      shortName: 'Sta/M',
      group: 'stam',
      preferred: prefGroup.all,
    }),
    // Versatile Amber
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7202,
      shortName: 'Sta/V',
      group: 'stam',
      preferred: prefGroup.all,
    }),
    // Solid Amber
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7205,
      shortName: 'Sta',
      group: 'stam',
      preferred: prefGroup.all,
    }),

    // Insightful Blasphemite
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7211,
      shortName: 'Pri/Mana',
      group: 'algari',
      preferred: prefGroup.caster,
    }),
    // Culminating Blasphemite
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7214,
      shortName: 'Pri/CE',
      group: 'algari',
      preferred: prefGroup.all,
    }),
    // Elusive Blasphemite
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7217,
      shortName: 'Pri/Spd',
      group: 'algari',
      preferred: prefGroup.all,
    }),
    // Cubic Blasphemia
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7251,
      shortName: 'Pri',
      group: 'algari',
    }),

    // PVP Gems

    // Enduring Bloodstone
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7220,
      maxQuality: 1,
      shortName: 'Pri/DR',
      group: 'algari',
    }),
    // Cognitive Bloodstone
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7221,
      maxQuality: 1,
      shortName: 'Pri/Precog',
      group: 'algari',
    }),
    // Determined Bloodstone
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 7222,
      maxQuality: 1,
      shortName: 'Pri/Snare',
      group: 'algari',
    }),


    //
    //
    // DRAGONFLIGHT
    //
    //


    // 10.0.7 Primordial Gems
    {
      itemId: 204000,
      id: 204000,
      name: 'Storm Infused Stone',
      icon: 'inv_10_elementalcombinedfoozles_lightning',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6755,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    }, {
      itemId: 204001,
      id: 204001,
      name: 'Echoing Thunder Stone',
      icon: 'inv_misc_reforgedarchstone_01',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6756,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    }, {
      itemId: 204002,
      id: 204002,
      name: 'Flame Licked Stone',
      icon: 'inv_elemental_primal_fire',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6757,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    }, {
      itemId: 204003,
      id: 204003,
      name: 'Raging Magma Stone',
      icon: 'inv_pet_scorchedstone',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6758,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    },
    {
      itemId: 204004,
      id: 204004,
      name: 'Searing Smokey Stone',
      icon: 'inv_misc_rune_04',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6759,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    },
    {
      itemId: 204005,
      id: 204005,
      name: 'Entropic Fel Stone',
      icon: 'spell_nature_elementalshields',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6760,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    },
    {
      itemId: 204006,
      id: 204006,
      name: 'Indomitable Earth Stone',
      icon: 'inv_elemental_primal_earth',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6761,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    },
    {
      itemId: 204007,
      id: 204007,
      name: 'Shining Obsidian Stone',
      icon: 'inv_stone_15',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6762,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    },
    {
      itemId: 204009,
      id: 204009,
      name: 'Gleaming Iron Stone',
      icon: 'inv_ore_mithril_01',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6764,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    },
    {
      itemId: 204010,
      id: 204010,
      name: 'Deluging Water Stone',
      icon: 'inv_elemental_primal_water',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6765,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    },
    {
      itemId: 204011,
      id: 204011,
      name: 'Freezing Ice Stone',
      icon: 'spell_frost_frozencore',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6766,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    },
    {
      itemId: 204012,
      id: 204012,
      name: 'Cold Frost Stone',
      icon: 'inv_enchant_shardshadowfrostlarge',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6767,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    },
    {
      itemId: 204013,
      id: 204013,
      name: 'Exuding Steam Stone',
      icon: 'inv_10_elementalcombinedfoozles_water',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6768,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    },
    {
      itemId: 204014,
      id: 204014,
      name: 'Sparkling Mana Stone',
      icon: 'inv_elemental_primal_mana',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6769,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    },
    {
      itemId: 204015,
      id: 204015,
      name: 'Swirling Mojo Stone',
      icon: 'inv_misc_gem_ebondraenite_02',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6770,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    },
    {
      itemId: 204018,
      id: 204018,
      name: 'Humming Arcane Stone',
      icon: 'inv_enchant_essencearcanelarge',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6773,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    },
    {
      itemId: 204019,
      id: 204019,
      name: 'Harmonic Music Stone',
      icon: 'inv_enchant_shardprismaticlarge',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6774,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    },
    {
      itemId: 204020,
      id: 204020,
      name: 'Wild Spirit Stone',
      icon: 'inv_elemental_primal_life',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6775,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    },
    {
      itemId: 204021,
      id: 204021,
      name: 'Necromantic Death Stone',
      icon: 'inv_ore_saronite_01',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6776,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    },
    {
      itemId: 204022,
      id: 204022,
      name: 'Pestilent Plague Stone',
      icon: 'inv_infernalbrimstone',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6777,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    },
    {
      itemId: 204025,
      id: 204025,
      name: 'Obscure Pastel Stone',
      icon: 'inv_enchant_prismaticsphere',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6780,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    },
    {
      itemId: 204027,
      id: 204027,
      name: 'Desirous Blood Stone',
      icon: 'inv_misc_gem_bloodstone_02',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6782,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    },
    {
      itemId: 204029,
      id: 204029,
      name: 'Prophetic Twilight Stone',
      icon: 'spell_fire_twilightfire',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6784,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    },
    {
      itemId: 204030,
      id: 204030,
      name: 'Wind Sculpted Stone',
      icon: 'inv_elemental_primal_air',
      quality: 4,
      type: 'PRIMORDIAL',
      enchantId: 6722,
      itemLevel: 411,
      group: 'primordial',
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
    },


    // Engineering tinkers -----------------------
    {
      itemId: 198289,
      id: 198289,
      name: 'Tinker: Alarm-O-Turret',
      icon: 'inv_10_engineering2_tinkermodules_color1',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 569,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6505,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },
    {
      itemId: 198290,
      id: 198290,
      name: 'Tinker: Alarm-O-Turret',
      icon: 'inv_10_engineering2_tinkermodules_color1',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 569,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6505,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },
    {
      itemId: 198291,
      id: 198291,
      name: 'Tinker: Alarm-O-Turret',
      icon: 'inv_10_engineering2_tinkermodules_color1',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 569,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6505,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },
    {
      itemId: 198295,
      id: 198295,
      name: 'Tinker: Breath of Neltharion',
      icon: 'inv_10_engineering2_tinkermodules_color3',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 571,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6508,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },
    {
      itemId: 198296,
      id: 198296,
      name: 'Tinker: Breath of Neltharion',
      icon: 'inv_10_engineering2_tinkermodules_color3',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 571,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6508,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },
    {
      itemId: 198297,
      id: 198297,
      name: 'Tinker: Breath of Neltharion',
      icon: 'inv_10_engineering2_tinkermodules_color3',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 571,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6508,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },
    {
      itemId: 198298,
      id: 198298,
      name: 'Tinker: Plane Displacer',
      icon: 'inv_10_engineering2_tinkermodules_color6',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 573,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6504,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },
    {
      itemId: 198299,
      id: 198299,
      name: 'Tinker: Plane Displacer',
      icon: 'inv_10_engineering2_tinkermodules_color6',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 573,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6504,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },
    {
      itemId: 198300,
      id: 198300,
      name: 'Tinker: Plane Displacer',
      icon: 'inv_10_engineering2_tinkermodules_color6',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 573,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6504,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },
    {
      itemId: 198301,
      id: 198301,
      name: 'Tinker: Supercollide-O-Tron',
      icon: 'inv_10_engineering2_tinkermodules_color5',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 575,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6502,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },
    {
      itemId: 198302,
      id: 198302,
      name: 'Tinker: Supercollide-O-Tron',
      icon: 'inv_10_engineering2_tinkermodules_color5',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 575,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6502,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },
    {
      itemId: 198303,
      id: 198303,
      name: 'Tinker: Supercollide-O-Tron',
      icon: 'inv_10_engineering2_tinkermodules_color5',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 575,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6502,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },
    {
      itemId: 198304,
      id: 198304,
      name: 'Tinker: Grounded Circuitry',
      icon: 'inv_10_engineering2_tinkermodules_color2',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 572,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6507,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },
    {
      itemId: 198305,
      id: 198305,
      name: 'Tinker: Grounded Circuitry',
      icon: 'inv_10_engineering2_tinkermodules_color2',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 572,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6692,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },
    {
      itemId: 198306,
      id: 198306,
      name: 'Tinker: Grounded Circuitry',
      icon: 'inv_10_engineering2_tinkermodules_color2',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 572,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6693,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },
    {
      itemId: 199188,
      id: 199188,
      name: 'Tinker: Polarity Amplifier',
      icon: 'inv_10_engineering2_tinkermodules_color4',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 574,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6535,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },
    {
      itemId: 199189,
      id: 199189,
      name: 'Tinker: Polarity Amplifier',
      icon: 'inv_10_engineering2_tinkermodules_color4',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 574,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6535,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },
    {
      itemId: 199190,
      id: 199190,
      name: 'Tinker: Polarity Amplifier',
      icon: 'inv_10_engineering2_tinkermodules_color4',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 574,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6535,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },
    {
      itemId: 201407,
      id: 201407,
      name: 'Tinker: Arclight Vital Correctors',
      icon: 'inv_10_engineering_device_gadget1_color2',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 570,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6691,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },
    {
      itemId: 201408,
      id: 201408,
      name: 'Tinker: Arclight Vital Correctors',
      icon: 'inv_10_engineering_device_gadget1_color2',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 570,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6691,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },
    {
      itemId: 201409,
      id: 201409,
      name: 'Tinker: Arclight Vital Correctors',
      icon: 'inv_10_engineering_device_gadget1_color2',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 570,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6691,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },
    {
      itemId: 205014,
      id: 205014,
      name: 'Tinker: Shadowflame Rockets',
      icon: 'inv_10_engineering2_tinkermodules_color3',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 573,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6831,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },
    {
      itemId: 205015,
      id: 205015,
      name: 'Tinker: Shadowflame Rockets',
      icon: 'inv_10_engineering2_tinkermodules_color3',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 573,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6831,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },
    {
      itemId: 205016,
      id: 205016,
      name: 'Tinker: Shadowflame Rockets',
      icon: 'inv_10_engineering2_tinkermodules_color3',
      quality: 3,
      unique: true,
      itemLimit: {
        category: 573,
        quantity: 1,
      },
      type: SOCKET_TYPES.TINKER,
      enchantId: 6831,
      expansion: EXPANSIONS.DRAGONFLIGHT.id,
      dps: false,
      preferred: null,
    },

    // Primalist Gems -----------------------

    // Inscribed Illimited Diamond
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6470,
      shortName: 'Pri/C',
      group: 'df-primalist',
      preferred: prefGroup.all,
    }),
    // Fierce Illimited Diamond
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6398,
      shortName: 'Pri/H',
      group: 'df-primalist',
      preferred: prefGroup.all,
    }),
    // Skillful Illimited Diamond
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6473,
      shortName: 'Pri/M',
      group: 'df-primalist',
      preferred: prefGroup.all,
    }),
    // Resplendent Illimited Diamond
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6476,
      shortName: 'Pri/V',
      group: 'df-primalist',
      preferred: prefGroup.all,
    }),



    // Crit Gems -----------------------
    // Deadly Alexstraszite
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6419,
      shortName: 'Crit',
      group: 'df-crit',
      preferred: prefGroup.all,
    }),
    // Crafty Alexstraszite
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6395,
      shortName: 'C/H',
      group: 'df-crit',
      preferred: prefGroup.all,
    }),
    // Sensei's Alexstraszite
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6413,
      shortName: 'C/M',
      group: 'df-crit',
      preferred: prefGroup.all,
    }),
    // Radiant Alexstraszite
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6416,
      shortName: 'C/V',
      group: 'df-crit',
      preferred: prefGroup.all,
    }),
    // Craft Queen's Ruby
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6392,
      shortName: 'C/H',
      group: 'df-crit',
    }),

    // Haste Gems -----------------------
    // Quick Ysemerald
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6443,
      shortName: 'Haste',
      group: 'df-haste',
      preferred: prefGroup.all,
    }),
    // Crafy Ysemerald
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6440,
      shortName: 'H/C',
      group: 'df-haste',
      preferred: prefGroup.all,
    }),
    // Keen Ysemerald
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6437,
      shortName: 'H/M',
      group: 'df-haste',
      preferred: prefGroup.all,
    }),
    // Energized Ysemerald
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6434,
      shortName: 'H/V',
      group: 'df-haste',
      preferred: prefGroup.all,
    }),
    // Energized Vibrant Emerald
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6404,
      shortName: 'H/V',
      group: 'df-haste',
      preferred: prefGroup.all,
    }),

    // Mast Gems -----------------------
    // Fractured Neltharite
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6455,
      shortName: 'Mast',
      group: 'df-mast',
      preferred: prefGroup.all,
    }),
    // Sensei's Neltharite
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6452,
      shortName: 'M/C',
      group: 'df-mast',
      preferred: prefGroup.all,
    }),
    // Keen Neltharite
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6449,
      shortName: 'M/H',
      group: 'df-mast',
      preferred: prefGroup.all,
    }),
    // Zen Neltharite
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6446,
      shortName: 'M/V',
      group: 'df-mast',
      preferred: prefGroup.all,
    }),
    // Sensei's Sundered Onyx
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6407,
      shortName: 'M/C',
      group: 'df-mast',
    }),

    // Vers Gems -----------------------
    // Stormy Malygite
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6431,
      shortName: 'Vers',
      group: 'df-vers',
      preferred: prefGroup.all,
    }),
    // Radiant Malygite
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6428,
      shortName: 'V/C',
      group: 'df-vers',
      preferred: prefGroup.all,
    }),
    // Energized Malygite
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6422,
      shortName: 'V/H',
      group: 'df-vers',
      preferred: prefGroup.all,
    }),
    // Zen Malygite
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6425,
      shortName: 'V/M',
      group: 'df-vers',
      preferred: prefGroup.all,
    }),
    // Zen Mystic Sapphire
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6401,
      shortName: 'V/M',
      group: 'df-vers',
      preferred: null,
    }),

    // Stam Gems -----------------------
    // Jagged Nozdorite
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6458,
      shortName: 'Sta/C',
      group: 'df-stam',
      preferred: prefGroup.tank,
    }),

    // Forceful Nozdorite
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6461,
      shortName: 'Sta/H',
      group: 'df-stam',
      preferred: prefGroup.tank,
    }),
    // Puissant Nozdorite
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6464,
      shortName: 'Sta/M',
      group: 'df-stam',
      preferred: prefGroup.tank,
    }),
    // Stady Nozdorite
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6467,
      shortName: 'Sta/V',
      group: 'df-stam',
      preferred: prefGroup.tank,
    }),
    // Solid Eternity Amber
    ...enchantInfoWithCraftingQualties({
      startEnchantId: 6410,
      shortName: 'Stam',
      group: 'df-stam',
      dps: false,
      preferred: null,
    }),
  ];
  const decorated = deepFreeze(
    // set some default values
    _.map(
      _.filter(gems),
      g => {
        return {
          slot: 'socket',
          dps: true,
          ...g,
        };
      },
    ),
  );
  return decorated;
});

export const getUniqueGems = () => (
  _.fromPairs(_.map(_.filter(getGemInfo(), g => g.unique), g => [g.shortName, g.name]))
);
export const getNormalGems = () => (
  _.fromPairs(_.map(_.filter(getGemInfo(), g => !g.unique), g => [g.shortName, g.name]))
);

export const getGems = () => _.fromPairs(_.map(_.filter(getGemInfo(), 'shortName'), g => [g.shortName, g.name]));

export const getGemDetails = gemId => _.find(getGemInfo(), { itemId: parseInt(gemId, 10) });
export const getGemDetailsByEnchantId = id => _.find(getGemInfo(), { id });
export const isGemUnique = gemId => _.get(getGemDetails(gemId), 'unique', false);
